import styled from 'styled-components'

/**
 * ver2(gold) 모바일 게임 목록 — m.gold8.bet /Lobby 실측(390 기준)
 *   위 띠(뒤로가기 + スロット/ライブカジノ) → (슬롯) 게임사 배너 → 왼쪽 게임사 카드 줄 + 오른쪽 검색·탭·게임 3열
 *   (라이브) 동그란 게임사 그림 3열.
 *   전역 CSS(mobile-*.css)의 클래스는 쓰지 않는다 — 탭을 바꿀 때 화면 폭이 바뀌던 원인이었다.
 */
const GOLD = '#c49001'
const RED = '#e8193c'

export const Page = styled.div`
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
  background: #1b1b1b;
  padding-bottom: 60px;
`

export const TopBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 56px;
  padding: 0 8px;
  background: #2b2e34;
`

export const Back = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  background: none;
  color: ${GOLD};
  cursor: pointer;
  svg { width: 30px; height: 30px; fill: currentColor; color: inherit; }
`

export const CatTab = styled.button`
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-radius: 6px;
  background: ${({ $on }) => ($on ? 'linear-gradient(180deg, #fbe2a4, #ecc16a)' : 'transparent')};
  font-size: 15px;
  font-weight: 700;
  color: ${({ $on }) => ($on ? '#9d0b09' : GOLD)};
  white-space: nowrap;
  cursor: pointer;
`

export const Banner = styled.img`
  display: block;
  width: 100%;
  height: auto;
`

export const Body = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 8px 0 0;
`

export const Side = styled.div`
  flex: 0 0 100px;
  width: 100px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const VendorCard = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  min-height: 74px;
  padding: 8px 4px;
  border: 0;
  border-radius: 0 12px 12px 0;
  background: ${({ $on }) => ($on ? '#f6dc9c' : '#2c2d31')};
  cursor: pointer;
  img { max-width: 64px; max-height: 32px; object-fit: contain; }
  span {
    font-size: 13px;
    font-weight: 700;
    line-height: 1.25;
    color: ${({ $on }) => ($on ? '#a87400' : GOLD)};
    text-align: center;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
  /* 선택된 카드 오른쪽 작은 삼각형 */
  ${({ $on }) => ($on ? `&::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    border-style: solid;
    border-width: 8px 0 8px 8px;
    border-color: transparent transparent transparent #f6dc9c;
  }` : '')}
`

export const Main = styled.div`
  flex: 1;
  min-width: 0;
`

export const SearchRow = styled.form`
  display: flex;
  gap: 6px;
  input {
    flex: 1;
    min-width: 0;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    font-size: 14px;
    color: #222;
    outline: none;
  }
  input::placeholder { color: #aaa; }
  button {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 36px;
    padding: 0 12px;
    border: 0;
    border-radius: 6px;
    background: ${RED};
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
    cursor: pointer;
  }
  svg { width: 16px; height: 16px; fill: currentColor; color: inherit; }
`

export const Tabs = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 10px;
`

export const Tab = styled.button`
  height: 34px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: ${({ $on }) => ($on ? '#c9a24c' : '#4f4f53')};
  font-size: 14px;
  font-weight: 700;
  color: ${({ $on }) => ($on ? '#2a1a00' : GOLD)};
  white-space: nowrap;
  cursor: pointer;
`

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  margin: 14px 0 10px;
  span {
    flex: 0 0 auto;
    padding: 4px 14px;
    border-radius: 18px;
    background: ${RED};
    font-size: 17px;
    font-weight: 700;
    color: #fff;
  }
  &::after {
    content: '';
    flex: 1;
    height: 2px;
    margin-left: -6px;
    background: ${RED};
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 8px;
`

export const Game = styled.button`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 0;
  border: 0;
  background: none;
  text-align: center;
  cursor: pointer;
`

export const Thumb = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #111;
  img { width: 100%; height: 100%; object-fit: cover; }
`

export const GameName = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 13px;
  line-height: 1.3;
  color: ${GOLD};
`

export const Empty = styled.p`
  margin: 30px 0;
  text-align: center;
  font-size: 14px;
  color: #888;
`

export const LiveGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 10px;
  padding: 16px 12px;
`

export const LiveItem = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  img { width: 100%; max-width: 110px; aspect-ratio: 214 / 200; object-fit: contain; }
  span {
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
    color: ${GOLD};
    text-align: center;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
`

export const LivePlaceholder = styled.div`
  width: 100%;
  max-width: 110px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background: #2c2d31;
`
